import * as links from "./links"

export default {
  ...links,
}
